import CheckBox from 'client/components/common/CheckBox/CheckBox'
import { TestableInterface } from 'client/components/common/interfaces/TestableInterface'
import paymentSchedulesKeys from 'client/components/txtkeys/paymentSchedulesKeys'
import { DraftInterface } from 'client/Interfaces/Draft/DraftInterface'
// typescript
import { StateInterface } from 'client/Interfaces/StateInterface'
import { QuotaTypes, SubscriptionInterface } from 'client/Interfaces/Subscription'
// misc
import { l } from 'client/Other/Translation'
// selectors
import {
  doesCurrentPlanSupportFeature,
  getCompanySubscriptionSelector,
} from 'client/reducers/Subscription/companySubscription'
import * as React from 'react'
import { connect } from 'react-redux'

import './PaymentScheduleSettings.scss'

interface IStateProps {
  subscription?: SubscriptionInterface
  subscribedToPaymentSchedules: boolean
}

export type PaymentScheduleType = 'schedule' | 'downPayment'

interface IExternalProps extends TestableInterface {
  draft: DraftInterface
  enabled: boolean
  onEnabledChange: (enabled: boolean) => void
  type: PaymentScheduleType
}

export type PaymentSchedulesSettingsPropsInterface = IExternalProps & IStateProps
const className = 'PaymentScheduleSettings'
export class PaymentScheduleSettingsClass extends React.Component<PaymentSchedulesSettingsPropsInterface, null> {
  public render(): JSX.Element {
    const premiumStar = !doesCurrentPlanSupportFeature(this.props.subscription, QuotaTypes.PAYMENT_SCHEDULE)
    const labels = {
      downPayment: l(paymentSchedulesKeys.invoiceEditor.type.deposit),
      schedule: l(paymentSchedulesKeys.invoiceEditor.label),
    }
    return (
      <div className={className} data-automation={this.props.automation}>
        <div className={`${className}-label`}>
          <CheckBox
            value={this.props.enabled}
            label={labels[this.props.type]}
            automation={`${this.props.automation}-downPaymentCheckbox`}
            onChange={(value) => this.props.onEnabledChange(value)}
          />
          {premiumStar && (
            <img className={`${className}-label__star`} src={'/images/premiumfeature/star_with_circle_green.svg'} />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: StateInterface): IStateProps => {
  return {
    subscription: state.subscriptionManagement.companySubscription.subscription,
    subscribedToPaymentSchedules: doesCurrentPlanSupportFeature(
      getCompanySubscriptionSelector(state),
      QuotaTypes.PAYMENT_SCHEDULE,
    ),
  }
}

export const PaymentScheduleSettings = connect<IStateProps, null, IExternalProps>(mapStateToProps)(
  PaymentScheduleSettingsClass,
)
